'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageViewComfy = function ImageViewComfy(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 9h4V5H3v4zm0 5h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zM8 9h4V5H8v4zm5-4v4h4V5h-4zm5 9h4v-4h-4v4zM3 19h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zm5 0h4v-4h-4v4zm0-14v4h4V5h-4z' })
  );
};
ImageViewComfy = (0, _pure2.default)(ImageViewComfy);
ImageViewComfy.displayName = 'ImageViewComfy';
ImageViewComfy.muiName = 'SvgIcon';

exports.default = ImageViewComfy;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/image/view-comfy.js
 ** module id = 2165
 ** module chunks = 0
 **/